import $ from 'jquery';
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import "vue-select/dist/vue-select.css";
import Toasted from 'vue-toasted';
import { WindowType } from '../../../../util';
import { Board, Ticket } from "../../../backend/backendapi";
import { KanbanState } from "../../kanban.model";
import DropZone from '../../../dropzone/DropZone';

declare var window: WindowType;

Vue.use(Toasted, { duration: 2000 });

@Component({
    name: 'PortModal',
    components: {
        DropZone,
    }
})
export default class PortModal extends Vue {
    @Prop({ required: true })
    modalId!: string;
    @Prop({ required: true })
    state!: KanbanState;
    @Prop({ required: true })
    board!: Board;
    @Prop({ required: true })
    flow!: Ticket;

    private tab: 'importFlow' | 'exportFlow' = 'importFlow';

    mounted(): void {
    }

    openModal(): void {
        $('#' + this.modalId).modal('show');
    }

    closeModal(): void {
        $('#' + this.modalId).modal('hide');
        this.onClose();
    }

    private onImported(count: number): void {
        this.$toasted.info(this.$t('kanbanImported').toString());
        this.closeModal();
        this.$emit('reload');
    }

    private exportFlow(): void {
        this.state.portApi.export(this.flow.id!)
            .then(res => {
                var url = window.URL.createObjectURL(res.data);
                var a = document.createElement('a');
                a.href = url;
                a.download = res.fileName!;
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();
                a.remove();  //afterwards we remove the element again         
            });
    }

    private onClose(): void {
        this.$emit('close');
    }

    private get url(): string {
        return window.application.baseUrl + "api/v1/kanban/PortAPIControllerUI/import/" + this.flow.id;
    }
}